/**
 * 时间戳 → 按店铺 UTC 偏移展示的本地时间字符串（YYYY-MM-DD HH:mm:ss）。
 * 偏移量来自 window.SHOP_UTC_OFFSET_ISO（由页面在加载本文件前注入），本文件不计算店铺时区。
 */
(function (global) {
  'use strict';

  function pad2(n) {
    var x = Number(n);
    return x < 10 ? '0' + x : String(x);
  }

  /**
   * 解析 +08:00 形式为相对 UTC 的分钟数（东为正）。
   */
  function parseOffsetIsoToMinutes(offsetIso) {
    if (offsetIso == null || offsetIso === '') return 0;
    var m = /^([+-])(\d{2}):(\d{2})$/.exec(String(offsetIso).trim());
    if (!m) return 0;
    var sign = m[1] === '+' ? 1 : -1;
    return sign * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10));
  }

  /**
   * 将接口时间戳转为毫秒（秒级与毫秒级均支持）。
   */
  function parseTimestampToMs(raw) {
    if (raw == null || raw === '') return null;
    var n = typeof raw === 'number' ? raw : Number(String(raw).trim());
    if (!Number.isFinite(n)) return null;
    if (Math.abs(n) < 1e12) return Math.round(n * 1000);
    return Math.round(n);
  }

  /**
   * 读取与 Liquid shop-timezone 一致注入的偏移（ISO 字符串，如 +08:00）。
   */
  function getShopUtcOffsetIso() {
    var v = global.SHOP_UTC_OFFSET_ISO;
    if (typeof v === 'string' && v.trim() !== '') return v.trim();
    return '+00:00';
  }

  /**
   * @param {*} raw 时间戳（秒或毫秒）或数字字符串
   * @param {string} [shopUtcOffsetIso] 可选，覆盖 window.SHOP_UTC_OFFSET_ISO
   * @returns {string} 格式化时间或 "-"
   */
  function formatTimestampBySiteTimezone(raw, shopUtcOffsetIso) {
    if (raw == null || raw === '') return '-';
    if (typeof raw === 'string' && raw.trim() === '') return '-';
    var ms = parseTimestampToMs(raw);
    if (ms == null || isNaN(ms)) return '-';
    var offsetIso =
      shopUtcOffsetIso != null && String(shopUtcOffsetIso).trim() !== ''
        ? String(shopUtcOffsetIso).trim()
        : getShopUtcOffsetIso();
    var offMin = parseOffsetIsoToMinutes(offsetIso);
    var adj = new Date(ms + offMin * 60 * 1000);
    if (isNaN(adj.getTime())) return '-';
    return (
      adj.getUTCFullYear() +
      '-' +
      pad2(adj.getUTCMonth() + 1) +
      '-' +
      pad2(adj.getUTCDate()) +
      ' ' +
      pad2(adj.getUTCHours()) +
      ':' +
      pad2(adj.getUTCMinutes()) +
      ':' +
      pad2(adj.getUTCSeconds())
    );
  }

  /**
   * 解析 YYYY-MM-DD
   */
  function parseYmd(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || '').trim());
    if (!m) return null;
    return { y: parseInt(m[1], 10), mo: parseInt(m[2], 10), d: parseInt(m[3], 10) };
  }

  /**
   * 店铺日历日 startYmd～endYmd（与表头 shop-timezone 同一偏移）→ 接口用 Unix 秒级时间戳。
   * 含起日 00:00:00、止日 23:59:59（按店铺偏移换算为 UTC 瞬间）。
   */
  function shopYmdRangeToQueryTimestampsSec(startYmd, endYmd, shopUtcOffsetIso) {
    var off = shopUtcOffsetIso != null && String(shopUtcOffsetIso).trim() !== ''
      ? String(shopUtcOffsetIso).trim()
      : getShopUtcOffsetIso();
    var offMin = parseOffsetIsoToMinutes(off);
    var a = parseYmd(startYmd);
    var b = parseYmd(endYmd);
    if (!a || !b) return null;
    var startMs = Date.UTC(a.y, a.mo - 1, a.d, 0, 0, 0, 0) - offMin * 60 * 1000;
    var endMs = Date.UTC(b.y, b.mo - 1, b.d, 23, 59, 59, 999) - offMin * 60 * 1000;
    if (startMs > endMs) {
      var t = startMs;
      startMs = endMs;
      endMs = t;
    }
    return {
      start: Math.floor(startMs / 1000),
      end: Math.floor(endMs / 1000),
    };
  }

  global.formatTimestampBySiteTimezone = formatTimestampBySiteTimezone;
  global.RRFormatTimestamp = {
    formatTimestampBySiteTimezone: formatTimestampBySiteTimezone,
    parseTimestampToMs: parseTimestampToMs,
    parseOffsetIsoToMinutes: parseOffsetIsoToMinutes,
    getShopUtcOffsetIso: getShopUtcOffsetIso,
    shopYmdRangeToQueryTimestampsSec: shopYmdRangeToQueryTimestampsSec,
  };
})(typeof window !== 'undefined' ? window : this);
